export const localDateValue = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const localDate = (value: string, endOfDay: boolean) => {
  const [year, month, day] = value.slice(0, 10).split('-').map(Number);
  return new Date(
    year,
    month - 1,
    day,
    endOfDay ? 23 : 0,
    endOfDay ? 59 : 0,
    endOfDay ? 59 : 0,
    endOfDay ? 999 : 0,
  );
};

export const toStartOfDayInstant = (value: string) => localDate(value, false).toISOString();
export const toEndOfDayInstant = (value: string) => localDate(value, true).toISOString();
